import { useEffect, useMemo, useRef } from 'react';
import { debounce } from '../util/helpers';

export const useDebounce = <T extends (...args: any[]) => void | Promise<void>>(
  callback: T,
  delay: number,
) => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = (...args: Parameters<T>) => {
      ref.current?.(...args);
    };

    return debounce(func, delay);
  }, [delay]);

  return debouncedCallback;
};
